import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { createApp, h } from 'vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import axios from './axios';

import 'slick-carousel/slick/slick.css';
import '../public/css/style.scss';
import 'promise-polyfill/src/polyfill';
import 'maz-ui/css/main.css'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import App from './App.vue';
import toast from '@/toast';

const app = createApp({
    render: () => h(App)
});

app.config.globalProperties.$http = axios;
app.config.globalProperties.$toast = toast;

app.use(router)
    .use(store)
    .use(toast)
    .use(i18n)
    .component('VuePhoneNumberInput', VuePhoneNumberInput);

app.mount('#app');